import styled from 'styled-components';
import { typography } from 'dab-component-lib';
import { MediaStyle, GridRowStyle, GridColStyle, basic } from '../../utils/style-utils';

export const IconWithTitleWrapperStyle = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
  ${props => props.track && `
    &:before {
      content: '';
      display: block;
      height: 100%;
      width: 1px;
      background: ${basic.secondary};
      position: absolute;
      left: 25px;
      top: 41px;
      z-index: 0;
    }
  `};
  ${ MediaStyle.md`
    ${props => props.border && `
      border-right: 2px solid ${basic.greyGreen};
      padding-right: 30px;
    `}
  ` }
`;

export const FullWidthStyle = styled.div`
  flex-grow: 1;
`;

export const IconWrapperStyle = styled.div`
  padding-right: 15px;
  position: relative;
  z-index: 1;
`;

export const TitleStyle = styled.h3`
  ${typography.Body1}
  color: ${basic.secondary};
  margin-top: 15px;
  ${ MediaStyle.md`
    padding-left: 1.125rem;
  `}
  ${props => props.withsubtitle && `
    margin-bottom: 0;
  `}
`;

export const SubtitleStyle = styled.div`
  ${typography.Body2}
  color: ${basic.secondary};
  ${ MediaStyle.md`
    padding-left: 1.125rem;
  `}
`;


export const DeselectedAreaStyle = styled.div`
  pointer-events: ${props => props.disable && "none"};
  opacity: ${props => props.disable && "0.4"};
  user-select: ${props => props.disable && "none"};
  margin-top: 30px;
`;

export const OrderRowStyle = GridRowStyle.extend`
  flex-direction: ${props => props.reverse ? "column-reverse" : "column"};
  flew-wrap: wrap;
  ${ MediaStyle.md`
    flex-direction: row;
    flew-wrap: nowrap;
  ` }
`;

export const OrderColStyle = GridColStyle.extend`
  ${props => props.third && `
    & > div {
      margin-bottom: 15px;
    }
  `}
  ${ MediaStyle.md`
    width: ${props => props.third ? '33%' : 'auto'};
    margin: ${props => props.third ? '0 15px 0 0' : '0 0 0 15px'};
    flex: ${props => props.third && 'none'};
    flex-grow: ${props => !props.third && '1'};
    flex-shrink: ${props => !props.third && '1'};
    flex-basis:${props => !props.third && '0'}; 
  ` }
`;


export const CategoryRowStyle = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 15px;
  & > div {
    width: 100%;
  }
  ${ MediaStyle.md`
    flex-wrap: nowrap;
    padding-left: 1.125rem;
    & > div {
      width: 30%;
      border-right: 1px solid ${basic.greyGreen};
      &:last-child {
        border-right: none;
      }
    }
  ` }
`;


export const ButtonWrapperStyle = styled.div`
  text-align: right;
`;

export const InputSearchWrapper = styled.div`
  margin-top: 15px;
`;

export const ResultsWrapperStyle = styled.div`
  margin: 15px 0;
  & > div {
    border-bottom: 1px solid ${basic.greyGreen};
  }
  ${ MediaStyle.md`
    display: flex;
    flex-wrap: wrap;
    & > div {
      width: 48%;
      border-right: 1px solid ${basic.greyGreen};
      border-bottom: none;
      margin-bottom: 15px;
      &:nth-child(2n) {
        border-right: none;
      }
    }
  ` }
`;


// WEBPACK FOOTER //
// ./src/components/orderDetails/style.js